import { IWeekDaysEnum } from 'types/graphqlTypes'

export const DAY_OPTIONS = [
  {
    value: IWeekDaysEnum.monday,
    label: 'Mon',
  },
  {
    value: IWeekDaysEnum.tuesday,
    label: 'Tue',
  },
  {
    value: IWeekDaysEnum.wednesday,
    label: 'Wed',
  },
  {
    value: IWeekDaysEnum.thursday,
    label: 'Thu',
  },
  {
    value: IWeekDaysEnum.friday,
    label: 'Fri',
  },
  {
    value: IWeekDaysEnum.saturday,
    label: 'Sat',
  },
  {
    value: IWeekDaysEnum.sunday,
    label: 'Sun',
  },
]
